import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Subscription } from '../../Domain/Subscription';
import { SubscriptionPlan } from '../../Domain/enums/SubscriptionPlan';
import { resetAppState } from '../actions/resetAppState';

interface SubscriptionState {
    currentSubscription: Subscription;
    isLoading: boolean;
    error: string | null;
}

const demoSubscription: Subscription = {
    plan: SubscriptionPlan.Demo,
    bagOfIdeasSize: 5,
    canGenerateLongerContent: false,
    creditsAvailable: 0,
    extraCredits: 0,
};

const createInitialState = (): SubscriptionState => ({
    currentSubscription: demoSubscription,
    isLoading: false,
    error: null,
});

const initialState: SubscriptionState = createInitialState();

export const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        setSubscription: (state, action: PayloadAction<Subscription>) => {
            state.currentSubscription = action.payload;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetSubscription: (state) => {
            state.currentSubscription = initialState.currentSubscription;
            state.isLoading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetAppState, () => createInitialState());
    }
});

export const { setSubscription, setLoading, setError, resetSubscription } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
